module.exports = __webpack_public_path__ + "img/industry_normal.6967a11.png";